/** @jsxImportSource @emotion/react */
import { useGetCatalogItemPictureQuery } from 'store/services/catalog'

type Props = {
  id: string
  hasPicture: boolean
  by?: 'lab' | 'dme'
  alt?: string
  className?: string
  width?: number | string
  height?: number | string
}

const placeholderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#f4f6f9',
  color: '#adb5bd',
  border: '1px solid #e9ecef',
  borderRadius: 4,
} as const

const CatalogItemImage = ({
  id,
  hasPicture,
  by = 'lab',
  alt = 'Catalog item',
  className,
  width = '100%',
  height = 160,
}: Props) => {
  const { data: src, isLoading } = useGetCatalogItemPictureQuery(
    { id, by },
    { skip: !hasPicture },
  )

  if (hasPicture && src) {
    return (
      <img
        src={src}
        alt={alt}
        className={className}
        css={{ width, height, objectFit: 'contain', borderRadius: 4 }}
      />
    )
  }

  return (
    <div className={className} css={{ ...placeholderStyle, width, height }}>
      {hasPicture && isLoading ? (
        <i className="fas fa-spinner fa-spin" />
      ) : (
        <i className="fas fa-image fa-2x" />
      )}
    </div>
  )
}

export default CatalogItemImage
